type Props = {
  number: string
  title: string
}

export const SectionHeading = ({ number, title }: Props) => {
  return (
    <h2 className="mb-8 flex items-baseline gap-4 text-sm">
      <span className="font-mono text-xs text-ink-400 tabular-nums tracking-wider">
        {number}
      </span>
      <span aria-hidden="true" className="text-ink-400 select-none">
        /
      </span>
      <span className="text-ink-800 font-medium tracking-wide">{title}</span>
    </h2>
  )
}
